/**
 * 统一判断接口响应是否为成功状态，兼容旧格式 success=true 和新格式 code=0/200。
 * @param {Object} responseData 接口返回的响应体数据。
 * @returns {boolean} 当前响应是否代表请求成功。
 */
export function isSuccessResponse(responseData) {
  // normalizedCode 用于把数字和字符串状态码统一成字符串后判断。
  const normalizedCode = responseData && responseData.code !== undefined
    ? String(responseData.code)
    : ''

  return Boolean(responseData && (responseData.success === true || normalizedCode === '0' || normalizedCode === '200'))
}

/**
 * 统一读取接口提示文案，避免页面里重复兜底 message 判断。
 * @param {Object} responseData 接口返回的响应体数据。
 * @param {string} fallbackMessage 接口没有返回 message 时使用的默认文案。
 * @returns {string} 可直接展示给用户的提示文案。
 */
export function getResponseMessage(responseData, fallbackMessage) {
  // responseMessage 保存后端返回的 message，缺失时使用页面传入的兜底文案。
  const responseMessage = responseData && responseData.message
    ? responseData.message
    : ''

  return responseMessage || fallbackMessage
}

/**
 * 统一读取接口 data 字段，便于页面按自己的结构继续取 list 或数组。
 * @param {Object} responseData 接口返回的响应体数据。
 * @param {*} fallbackPayload 接口没有返回 data 时使用的默认数据。
 * @returns {*} 接口 data 字段或默认数据。
 */
export function getResponsePayload(responseData, fallbackPayload) {
  // hasPayload 用于区分 data 为空字符串、0 等有效值和 data 字段不存在的情况。
  const hasPayload = responseData && Object.prototype.hasOwnProperty.call(responseData, 'data')

  return hasPayload ? responseData.data : fallbackPayload
}
